export default __webpack_public_path__ + "static/media/kanban3.391011aa.png";